export default "__VITE_ASSET__DrgQEqlZ__"